/* Storico versioni: elenco, con ripristino per chi ha ruolo editor+. */
import { api, ApiError, type User } from "../api.js";
import { el } from "../render/svg.js";
import { modal } from "./modal.js";

const fmt = (iso: string): string => new Date(iso).toLocaleString("it-IT");

export async function openVersionsModal(
  root: HTMLElement,
  user: User,
  diagramId: number,
  onChanged: () => Promise<void> | void,
): Promise<void> {
  const { body, close } = modal(root, "Storico versioni");
  body.textContent = "Caricamento…";
  const canEdit = user.role !== "viewer";
  try {
    const { versions } = await api.listVersions(diagramId);
    body.textContent = "";
    if (!versions.length) {
      body.appendChild(el("p", "hint", "Nessuna versione."));
      return;
    }
    for (const v of versions) {
      const row = el("div", "ver-row" + (v.current ? " current" : ""));
      const meta = el("div", "ver-meta");
      meta.appendChild(el("div", "ver-title", v.message || "(senza messaggio)"));
      meta.appendChild(
        el("div", "ver-sub", `#${v.id} · ${fmt(v.createdAt)} · ${v.author ?? "—"}${v.current ? " · corrente" : ""}`),
      );
      row.appendChild(meta);
      if (canEdit && !v.current) {
        const b = el("button", "btn sm", "Ripristina") as HTMLButtonElement;
        b.type = "button";
        b.addEventListener("click", async () => {
          b.disabled = true;
          b.textContent = "…";
          try {
            await api.restoreVersion(diagramId, v.id);
            await onChanged();
            close();
          } catch (e) {
            b.disabled = false;
            b.textContent = "Ripristina";
            row.appendChild(el("span", "login-err", e instanceof ApiError ? e.message : "errore"));
          }
        });
        row.appendChild(b);
      }
      body.appendChild(row);
    }
  } catch (e) {
    body.textContent = "Errore: " + (e instanceof Error ? e.message : String(e));
  }
}
